import React, { useState } from 'react';

const QUICK_QUESTIONS = [
  'How does chat work?',
  'How do permissions help?',
  'Can I control my privacy?',
  'What should I do in emergency?',
];

function getReply(question) {
  const q = question.toLowerCase();
  if (q.includes('chat')) return 'Use the Chat page to message your parent in real time. Messages are secure and instant.';
  if (q.includes('permission') || q.includes('privacy')) return 'Open Permissions page and toggle camera/mic/location/screen access anytime.';
  if (q.includes('emergency') || q.includes('sos')) return 'If you feel unsafe, message your parent immediately and keep location access enabled.';
  if (q.includes('location')) return 'Location sharing helps your parent find you quickly and keeps your routes safe.';
  return 'I can help with chat, permissions, safety, and app settings. Ask me anything.';
}

export default function ChildHelpPage() {
  const [input, setInput] = useState('');
  const [messages, setMessages] = useState([
    { role: 'ai', text: 'Hi! I am your AI guide. Ask me how this app works.' },
  ]);

  const ask = (text) => {
    if (!text.trim()) return;
    const userText = text.trim();
    setMessages((prev) => [...prev, { role: 'user', text: userText }, { role: 'ai', text: getReply(userText) }]);
    setInput('');
  };

  return (
    <div>
      <div className="card hero-card" style={{ marginBottom: 20 }}>
        <div className="hero-title">AI Help Session 🤖</div>
        <div className="hero-subtitle">Instant guidance to make the app smooth and easy.</div>
      </div>

      <div className="card" style={{ marginBottom: 16 }}>
        <div className="card-header">
          <div className="card-title">Quick Questions</div>
        </div>
        <div style={{ display: 'flex', flexWrap: 'wrap', gap: 10 }}>
          {QUICK_QUESTIONS.map((q) => (
            <button key={q} className="btn btn-outline btn-sm" onClick={() => ask(q)}>{q}</button>
          ))}
        </div>
      </div>

      <div className="card" style={{ marginBottom: 16 }}>
        <div style={{ display: 'grid', gap: 10 }}>
          {messages.map((m, idx) => (
            <div
              key={idx}
              style={{
                maxWidth: '85%',
                marginLeft: m.role === 'user' ? 'auto' : 0,
                background: m.role === 'user' ? 'var(--gradient-blue)' : 'var(--bg-secondary)',
                color: m.role === 'user' ? '#fff' : 'var(--text-primary)',
                border: '1px solid var(--border)',
                borderRadius: 14,
                padding: '10px 12px',
                fontSize: 13,
                lineHeight: 1.45,
              }}
            >
              {m.text}
            </div>
          ))}
        </div>
      </div>

      <div className="card">
        <div style={{ display: 'flex', gap: 10 }}>
          <input
            className="form-input"
            placeholder="Ask anything..."
            value={input}
            onChange={(e) => setInput(e.target.value)}
            onKeyDown={(e) => {
              if (e.key === 'Enter') ask(input);
            }}
          />
          <button className="btn btn-primary" onClick={() => ask(input)}>Ask</button>
        </div>
      </div>
    </div>
  );
}
